import { createDraftJobPost } from './CreateDraftJobPost';
import { getInvitableOnsiteInterviews } from './GetInvitableOnsiteInterviews';
import { createOnsiteInterviews } from './CreateOnsiteInterview';
import { createShortlistCandidate } from './CreateShortlistCandidate';
import { deleteDraftJob } from './DeleteDraftJob';
import { deleteShortlistCandidate } from './DeleteShortlistCandidate';
import { getCandidateList } from './GetCandidateList';
import { getEligibleCandidates } from './GetEligibleCandidates';
import { getCandidateProfessional } from './GetCandidateProfessional';
import { getCandidateResume } from './GetCandidateResume';
import { getJobPostDetail } from './GetJobPostDetail';
import { getJobPostings } from './GetJobPostings';
import { getOfficePlanDetail } from './GetOfficePlanDetail';
import { getOnsiteInterviewList } from './GetOnsiteInterviewList';
import { getOnsiteInterviewStatusCount } from './GetOnsiteInterviewStatusCount';
import { getPostingPlans } from './GetPostingPlans';
import { parsePosting } from './ParsePosting';
import { publishDraftJobPost } from './PublishDraftJobPost';
import { retryBilling } from './RetryBilling';
import { saveJobPostDetail } from './SaveJobPostDetail';
import { getCandidateOnsiteInterviewList } from './GetCandidateOnsiteInterviewList';
import { postPermValuePropViewed } from './PostPermValuePropViewed';
import { updateCandidateStatus } from './UpdateCandidateStatus';
import { generateJobDescription } from './GenerateJobDescription';

export const PermanentJobsApi = {
  getCandidateOnsiteInterviewList,
  createDraftJobPost,
  createOnsiteInterviews,
  createShortlistCandidate,
  deleteDraftJob,
  deleteShortlistCandidate,
  getCandidateList,
  getEligibleCandidates,
  getCandidateProfessional,
  getCandidateResume,
  getJobPostDetail,
  getJobPostings,
  getOfficePlanDetail,
  getOnsiteInterviewList,
  getOnsiteInterviewStatusCount,
  getPostingPlans,
  parsePosting,
  publishDraftJobPost,
  retryBilling,
  saveJobPostDetail,
  postPermValuePropViewed,
  updateCandidateStatus,
  getInvitableOnsiteInterviews,
  generateJobDescription,
};
